// Matches backend enum Signalync.Core.Enums.Plan { Starter, Advanced, Professional, Expired }.
// UserController sends the enum name on the wire; StepsController does not lowercase
// planRequired. Comparison is case-insensitive.
// "expired" is treated as the lowest tier (locked-out state).
const PLAN_ORDER = ["expired", "starter", "advanced", "professional"] as const;

export function isPlanSufficient(required: string, userPlan: string): boolean {
  const reqIdx = PLAN_ORDER.indexOf(required.toLowerCase() as (typeof PLAN_ORDER)[number]);
  const userIdx = PLAN_ORDER.indexOf(userPlan.toLowerCase() as (typeof PLAN_ORDER)[number]);
  if (reqIdx === -1) return true; // unknown required plan → don't block
  if (userIdx === -1) return false; // unknown user plan → treat as expired (block)
  return userIdx >= reqIdx;
}

export function planLabel(plan: string): string {
  const lower = plan.toLowerCase();
  if (lower === "expired") return "";
  return plan.charAt(0).toUpperCase() + plan.slice(1).toLowerCase();
}
